// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/intro-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Theme Name: NewBiz
  Theme URL: https://bootstrapmade.com/newbiz-bootstrap-business-template/
  Author: BootstrapMade.com
  License: https://bootstrapmade.com/license/
*/

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/

body {
  padding: 0%;
  background: #fff;
  color: #444;
  font-family: "Open Sans", sans-serif;
}

a {
  color: #007bff;
  transition: 0.5s;
}

a:hover,
a:active,
a:focus {
  color: #0b6bd3;
  outline: none;
  text-decoration: none;
}

p {
  padding: 0;
  margin: 0 0 30px 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  margin: 0 0 20px 0;
  padding: 0;
}

/* Back to top button */

.back-to-top {
  position: fixed;
  display: none;
  background: #007bff;
  color: #fff;
  width: 44px;
  height: 44px;
  text-align: center;
  line-height: 1;
  font-size: 16px;
  border-radius: 50%;
  right: 15px;
  bottom: 15px;
  transition: background 0.5s;
  z-index: 11;
}

.back-to-top i {
  padding-top: 12px;
  color: #fff;
}

/* Prelaoder */

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  overflow: hidden;
  background: #fff;
}

#preloader:before {
  content: "";
  position: fixed;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  border: 6px solid #f2f2f2;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: animate-preloader 1s linear infinite;
}

@keyframes animate-preloader {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/

#header {
  height: 80px;
  transition: all 0.5s;
  z-index: 997;
  transition: all 0.5s;
  padding: 20px 0;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.3);
}

#header.header-scrolled,
#header.header-pages {
  height: 60px;
  padding: 10px 0;
}

#header .logo h1 {
  font-size: 36px;
  margin: 0;
  padding: 0;
  line-height: 1;
  font-weight: 400;
  letter-spacing: 3px;
  text-transform: uppercase;
}

#header .logo h1 a,
#header .logo h1 a:hover {
  color: #00366f;
  text-decoration: none;
}

#header .logo img {
  padding: 0;
  margin: 7px 0;
  max-height: 26px;
}

.main-pages {
  margin-top: 60px;
}

/*--------------------------------------------------------------
# Intro Section
--------------------------------------------------------------*/

#intro {
  width: 100%;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  background-size: cover;
  padding: 200px 0 120px 0;
}

#intro .intro-img {
  width: 50%;
  float: right;
}

#intro .intro-info {
  width: 50%;
  float: left;
}

#intro .intro-info h2 {
  color: #fff;
  margin-bottom: 40px;
  font-size: 48px;
  font-weight: 700;
}

#intro .intro-info h2 span {
  color: #74b5fc;
  text-decoration: underline;
}

#intro .intro-info .btn-get-started,
#intro .intro-info .btn-services {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  display: inline-block;
  padding: 10px 32px;
  border-radius: 50px;
  transition: 0.5s;
  margin: 0 20px 20px 0;
  color: #fff;
}

#intro .intro-info .btn-get-started {
  background: #007bff;
  border: 2px solid #007bff;
  color: #fff;
}

#intro .intro-info .btn-get-started:hover {
  background: none;
  border-color: #fff;
  color: #fff;
}

#intro .intro-info .btn-services {
  border: 2px solid #fff;
}

#intro .intro-info .btn-services:hover {
  background: #007bff;
  border-color: #007bff;
  color: #fff;
}

.centered-button{
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/

/* Desktop Navigation */

.main-nav {
  /* Drop Down */
  /* Deep Drop Down */
}

.main-nav,
.main-nav * {
  margin: 0;
  padding: 0;
  list-style: none;
}

.main-nav > ul > li {
  position: relative;
  white-space: nowrap;
  float: left;
}

.main-nav a {
  display: block;
  position: relative;
  color: #004289;
  padding: 10px 15px;
  transition: 0.3s;
  font-size: 18px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.main-nav a:hover,
.main-nav .active > a,
.main-nav li:hover > a {
  color: #007bff;
  text-decoration: none;
}

.main-nav .drop-down ul {
  display: block;
  position: absolute;
  left: 0;
  top: calc(100% + 30px);
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  padding: 10px 0;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
  transition: ease all 0.3s;
}

.main-nav .drop-down:hover > ul {
  opacity: 1;
  top: 100%;
  visibility: visible;
}

.main-nav .drop-down li {
  min-width: 180px;
  position: relative;
}

.main-nav .drop-down ul a {
  padding: 10px 20px;
  font-size: 13px;
  color: #004289;
}

.main-nav .drop-down ul a:hover,
.main-nav .drop-down ul .active > a,
.main-nav .drop-down ul li:hover > a {
  color: #007bff;
}

.main-nav .drop-down > a:after {
  content: "\\f107";
  font-family: FontAwesome;
  padding-left: 10px;
}

.main-nav .drop-down .drop-down ul {
  top: 0;
  left: calc(100% - 30px);
}

.main-nav .drop-down .drop-down:hover > ul {
  opacity: 1;
  top: 0;
  left: 100%;
}

.main-nav .drop-down .drop-down > a {
  padding-right: 35px;
}

.main-nav .drop-down .drop-down > a:after {
  content: "\\f105";
  position: absolute;
  right: 15px;
}

/* Mobile Navigation */

.mobile-nav {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 9999;
  overflow-y: auto;
  left: -260px;
  width: 260px;
  padding-top: 18px;
  background: rgba(19, 39, 57, 0.8);
  transition: 0.4s;
}

.mobile-nav * {
  margin: 0;
  padding: 0;
  list-style: none;
}

.mobile-nav a {
  display: block;
  position: relative;
  color: #fff;
  padding: 10px 20px;
  font-weight: 500;
}

.mobile-nav a:hover,
.mobile-nav .active > a,
.mobile-nav li:hover > a {
  color: #74b5fc;
  text-decoration: none;
}

.mobile-nav .drop-down > a:after {
  content: "\\f078";
  font-family: FontAwesome;
  padding-left: 10px;
  position: absolute;
  right: 15px;
}

.mobile-nav .active.drop-down > a:after {
  content: "\\f077";
}

.mobile-nav .drop-down > a {
  padding-right: 35px;
}

.mobile-nav .drop-down ul {
  display: none;
  overflow: hidden;
}

.mobile-nav .drop-down li {
  padding-left: 20px;
}

.mobile-nav-toggle {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9998;
  border: 0;
  background: none;
  font-size: 24px;
  transition: all 0.4s;
  outline: none !important;
  line-height: 1;
  cursor: pointer;
  text-align: right;
}

.mobile-nav-toggle i {
  margin: 18px 18px 0 0;
  color: #004289;
}

.mobile-nav-overly {
  width: 100%;
  height: 100%;
  z-index: 9997;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(19, 39, 57, 0.8);
  overflow: hidden;
  display: none;
}

.mobile-nav-active {
  overflow: hidden;
}

.mobile-nav-active .mobile-nav {
  left: 0;
}

.mobile-nav-active .mobile-nav-toggle i {
  color: #fff;
}

/*--------------------------------------------------------------
# Sections
--------------------------------------------------------------*/

/* Sections Header
--------------------------------*/

.section-header h3 {
  font-size: 36px;
  color: #283d50;
  text-align: center;
  font-weight: 500;
  position: relative;
}

.section-header p {
  text-align: center;
  margin: auto;
  font-size: 15px;
  padding-bottom: 60px;
  color: #556877;
  width: 50%;
}

/* Section with background
--------------------------------*/

.section-bg {
  background: #ecf5ff;
}

/* About Us Section
--------------------------------*/

#about {
  background: #fff;
  padding: 60px 0;
}

#about .about-container .background {
  margin: 20px 0;
}

#about .about-container .content {
  background: #fff;
}

#about .about-container .title {
  color: #333;
  font-weight: 700;
  font-size: 32px;
}

#about .about-container p {
  line-height: 26px;
}

#about .about-container p:last-child {
  margin-bottom: 0;
}

#about .about-container .icon-box {
  background: #fff;
  background-size: cover;
  padding: 0 0 30px 0;
}

#about .about-container .icon-box .icon {
  float: left;
  background: #fff;
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  border-radius: 50%;
  border: 2px solid #007bff;
  transition: all 0.3s ease-in-out;
}

#about .about-container .icon-box .icon i {
  color: #007bff;
  font-size: 24px;
}

#about .about-container .icon-box:hover .icon {
  background: #007bff;
}

#about .about-container .icon-box:hover .icon i {
  color: #fff;
}

#about .about-container .icon-box .title {
  margin-left: 80px;
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 18px;
}

#about .about-container .icon-box .title a {
  color: #283d50;
}

#about .about-container .icon-box .description {
  margin-left: 80px;
  line-height: 24px;
  font-size: 14px;
}

#about .about-extra {
  padding-top: 60px;
}

#about .about-extra h4 {
  font-weight: 600;
  font-size: 24px;
}

/* Services Section
--------------------------------*/

#services {

  padding: 10px 0 0px 0;
  box-shadow: inset 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
}

#services .box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;

  margin: 0 auto 40px auto;
    /* Center the box and set the width to 80% */
    width: 100%;
  /* margin: 0 10px 40px 10px; */
  background: #ffffff;
  box-shadow: 0 10px 29px 0 rgba(68, 88, 144, 0.1);
  transition: all 0.3s ease-in-out;
}


#services .box:hover {
  transform: translateY(-5px);
}

#services .icon {
  position: absolute;
  left: 2px;
  padding: 10px 10px;
  top: calc(50% - 32px);
}

#services .icon i {
  font-size: 64px;
  line-height: 1;
  transition: 0.5s;
}

#services .title {
  margin-left: 40px;
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
}

#services .title a {
  color: #111;
  padding-left: 15px;
}

#services .box:hover .title a {
  color: #007bff;
}

#services .description {
  font-size: 14px;
  margin-left: 40px;
  line-height: 24px;
  padding-left: 15px;
  margin-bottom: 0;
}

#why-us {
  padding: 60px 0;
  background: #004a99;
}

#why-us .section-header h3,
#why-us .section-header p {
  color: #fff;
}

#why-us .card {
  background: #00458f;
  border-color: #00458f;
  border-radius: 10px;
  margin: 0 15px;
  padding: 15px 0;
  text-align: center;
  color: #fff;
  transition: 0.3s ease-in-out;
  height: 100%;
}

#why-us .card:hover {
  background: #003b7a;
  border-color: #003b7a;
}

#why-us .card i {
  font-size: 48px;
  padding-top: 15px;
  color: #bfddfe;
}

#why-us .card h5 {
  font-size: 22px;
  font-weight: 600;
}

#why-us .card p {
  font-size: 15px;
  color: #d8eafe;
}

#why-us .card .readmore {
  color: #fff;
  font-weight: 600;
  display: inline-block;
  transition: 0.3s ease-in-out;
  border-bottom: #00458f solid 2px;
}

#why-us .card .readmore:hover {
  border-bottom: #fff solid 2px;
}

#why-us .counters {
  padding-top: 40px;
}

#why-us .counters span {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 48px;
  display: block;
  color: #fff;
}

#why-us .counters p {
  padding: 0;
  margin: 0 0 20px 0;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  color: #cce5ff;
}

/* Portfolio Section
--------------------------------*/

#portfolio {
  padding: 60px 0;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
}

#portfolio #portfolio-flters {
  padding: 0;
  margin: 5px 0 35px 0;
  list-style: none;
  text-align: center;
}

#portfolio #portfolio-flters li {
  cursor: pointer;
  margin: 15px 15px 15px 0;
  display: inline-block;
  padding: 6px 20px;
  font-size: 12px;
  line-height: 20px;
  color: #007bff;
  border-radius: 50px;
  text-transform: uppercase;
  background: #ecf5ff;
  margin-bottom: 5px;
  transition: all 0.3s ease-in-out;
}

#portfolio #portfolio-flters li:hover,
#portfolio #portfolio-flters li.filter-active {
  background: #007bff;
  color: #fff;
}

#portfolio #portfolio-flters li:last-child {
  margin-right: 0;
}

#portfolio .portfolio-item {
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;
}

#portfolio .portfolio-item .portfolio-wrap {
  overflow: hidden;
  position: relative;
  border-radius: 6px;
  margin: 0;
}

#portfolio .portfolio-item .portfolio-wrap:hover img {
  opacity: 0.4;
  transition: 0.3s;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  opacity: 0;
  transition: 0.2s linear;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info h4 {
  font-size: 22px;
  line-height: 1px;
  font-weight: 700;
  margin-bottom: 14px;
  padding-bottom: 0;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info h4 a {
  color: #fff;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info h4 a:hover {
  color: #007bff;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info p {
  padding: 0;
  margin: 0;
  color: #e2effe;
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-preview,
#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-details {
  display: inline-block;
  line-height: 1;
  text-align: center;
  width: 36px;
  height: 36px;
  background: #007bff;
  border-radius: 50%;
  margin: 10px 4px 0 4px;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-preview i,
#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-details i {
  padding-top: 6px;
  font-size: 22px;
  color: #fff;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-preview:hover,
#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-details:hover {
  background: #3395ff;
}

#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-preview:hover i,
#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-details:hover i {
  color: #fff;
}

#portfolio .portfolio-item .portfolio-wrap:hover {
  background: #003166;
}

#portfolio .portfolio-item .portfolio-wrap:hover .portfolio-info {
  opacity: 1;
}

/* Testimonials Section
--------------------------------*/

#testimonials {
  padding: 60px 0;
  box-shadow: inset 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
}

#testimonials .section-header {
  margin-bottom: 40px;
}

#testimonials .testimonial-item .testimonial-img {
  width: 120px;
  border-radius: 50%;
  border: 4px solid #fff;
  float: left;
}

#testimonials .testimonial-item h3 {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0 5px 0;
  color: #111;
  margin-left: 140px;
}

#testimonials .testimonial-item h4 {
  font-size: 14px;
  color: #999;
  margin: 0 0 15px 0;
  margin-left: 140px;
}

#testimonials .testimonial-item p {
  font-style: italic;
  margin: 0 0 15px 140px;
}

#testimonials .owl-nav,
#testimonials .owl-dots {
  margin-top: 5px;
  text-align: center;
}

#testimonials .owl-dot {
  display: inline-block;
  margin: 0 5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ddd;
}

#testimonials .owl-dot.active {
  background-color: #007bff;
}

/* Team Section
--------------------------------*/

#team {
  background: #fff;
  padding: 60px 0;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
}

#team .member {
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;
}

#team .member .member-info {
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  transition: 0.2s;
}

#team .member .member-info-content {
  margin-top: 50px;
  transition: margin 0.2s;
}

#team .member:hover .member-info {
  background: rgba(0, 62, 128, 0.7);
  opacity: 1;
  transition: 0.4s;
}

#team .member:hover .member-info-content {
  margin-top: 0;
  transition: margin 0.4s;
}

#team .member h4 {
  font-weight: 700;
  margin-bottom: 2px;
  font-size: 18px;
  color: #fff;
}

#team .member span {
  font-style: italic;
  display: block;
  font-size: 13px;
  color: #fff;
}

#team .member .social {
  margin-top: 15px;
}

#team .member .social a {
  transition: none;
  color: #fff;
}

#team .member .social a:hover {
  color: #007bff;
}

#team .member .social i {
  font-size: 18px;
  margin: 0 2px;
}

/* Clients Section
--------------------------------*/

#clients {
  padding: 60px 0;
  box-shadow: inset 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
}

#clients .clients-wrap {
  border-top: 1px solid #d6eaff;
  border-left: 1px solid #d6eaff;
  margin-bottom: 30px;
}

#clients .client-logo {
  padding: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #d6eaff;
  border-bottom: 1px solid #d6eaff;
  overflow: hidden;
  background: #fff;
  height: 160px;
}

#clients .client-logo:hover img {
  transform: scale(1.2);
}

#clients img {
  transition: all 0.4s ease-in-out;
}

/* Contact Section
--------------------------------*/

#contact {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  padding: 60px 0;
  overflow: hidden;
}

#contact .section-header {
  padding-bottom: 30px;
}

#contact .contact-about h3 {
  font-size: 36px;
  margin: 0 0 10px 0;
  padding: 0;
  line-height: 1;
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #007bff;
}

#contact .contact-about p {
  font-size: 14px;
  line-height: 24px;
  font-family: "Montserrat", sans-serif;
  color: #888;
}

#contact .social-links {
  padding-bottom: 20px;
}

#contact .social-links a {
  font-size: 18px;
  display: inline-block;
  background: #fff;
  color: #007bff;
  line-height: 1;
  padding: 8px 0;
  margin-right: 4px;
  border-radius: 50%;
  text-align: center;
  width: 36px;
  height: 36px;
  transition: 0.3s;
  border: 1px solid #007bff;
}

#contact .social-links a:hover {
  background: #007bff;
  color: #fff;
}

#contact .info {
  color: #283d50;
}

#contact .info i {
  font-size: 32px;
  color: #007bff;
  float: left;
  line-height: 1;
}

#contact .info p {
  padding: 0 0 10px 36px;
  line-height: 28px;
  font-size: 14px;
}

#contact .form #sendmessage {
  color: #007bff;
  border: 1px solid #007bff;
  display: none;
  text-align: center;
  padding: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}

#contact .form #errormessage {
  color: red;
  display: none;
  border: 1px solid red;
  text-align: center;
  padding: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}

#contact .form #sendmessage.show,
#contact .form #errormessage.show,
#contact .form .show {
  display: block;
}

#contact .form .validation {
  color: red;
  display: none;
  margin: 0 0 20px;
  font-weight: 400;
  font-size: 13px;
}

#contact .form input,
#contact .form textarea {
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
}

#contact .form button[type="submit"] {
  background: #007bff;
  border: 0;
  border-radius: 20px;
  padding: 8px 30px;
  color: #fff;
  transition: 0.3s;
}

#contact .form button[type="submit"]:hover {
  background: #0067d5;
  cursor: pointer;
}

/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/

#footer {
  background: #00428a;
  padding: 0 0 30px 0;
  color: #eee;
  font-size: 14px;
}

#footer .footer-top {
  background: #004a99;
  padding: 60px 0 30px 0;
}

#footer .footer-top .footer-info {
  margin-bottom: 30px;
}

#footer .footer-top .footer-info h3 {
  font-size: 34px;
  margin: 0 0 20px 0;
  padding: 2px 0 2px 0;
  line-height: 1;
  font-family: "Montserrat", sans-serif;
  color: #fff;
  font-weight: 400;
  letter-spacing: 3px;
  text-transform: uppercase;
}

#footer .footer-top .footer-info p {
  font-size: 13px;
  line-height: 24px;
  margin-bottom: 0;
  font-family: "Montserrat", sans-serif;
  color: #ecf5ff;
}

#footer .footer-top .social-links a {
  font-size: 18px;
  display: inline-block;
  background: #007bff;
  color: #fff;
  line-height: 1;
  padding: 8px 0;
  margin-right: 4px;
  border-radius: 50%;
  text-align: center;
  width: 36px;
  height: 36px;
  transition: 0.3s;
}

#footer .footer-top .social-links a:hover {
  background: #0067d5;
  color: #fff;
}

#footer .footer-top h4 {
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 10px;
}

#footer .footer-top .footer-links {
  margin-bottom: 30px;
}

#footer .footer-top .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

#footer .footer-top .footer-links ul li {
  padding: 8px 0;
}

#footer .footer-top .footer-links ul li:first-child {
  padding-top: 0;
}

#footer .footer-top .footer-links ul a {
  color: #ecf5ff;
}

#footer .footer-top .footer-links ul a:hover {
  color: #74b5fc;
}

#footer .footer-top .footer-contact {
  margin-bottom: 30px;
}

#footer .footer-top .footer-contact p {
  line-height: 26px;
}

#footer .footer-top .footer-newsletter {
  margin-bottom: 30px;
}

#footer .footer-top .footer-newsletter input[type="email"] {
  border: 0;
  padding: 6px 8px;
  width: 65%;
}

#footer .footer-top .footer-newsletter input[type="submit"] {
  background: #007bff;
  border: 0;
  width: 35%;
  padding: 6px 0;
  text-align: center;
  color: #fff;
  transition: 0.3s;
  cursor: pointer;
}

#footer .footer-top .footer-newsletter input[type="submit"]:hover {
  background: #0062cc;
}

#footer .copyright {
  text-align: center;
  padding-top: 30px;
}

#footer .credits {
  text-align: center;
  font-size: 13px;
  color: #f1f7ff;
}

#footer .credits a {
  color: #bfddfe;
}

#footer .credits a:hover {
  color: #f1f7ff;
}

/*--------------------------------------------------------------
# Responsive Media Queries
--------------------------------------------------------------*/

@media (min-width: 992px) {
  #testimonials .testimonial-item p {
    width: 80%;
  }
}

@media (max-width: 991px) {
  #header {
    height: 60px;
    padding: 10px 0;
  }

  #header .logo h1 {
    font-size: 28px;
    padding: 8px 0;
  }

  #intro {
    padding: 140px 0 60px 0;

  }

  #intro .intro-img {
    width: 80%;


    float: none;
    margin: 0 auto 25px auto;
  }

  #intro .intro-info {
    width: 80%;
    float: none;
    margin: auto;
    text-align: center;
  }

  #why-us .card {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .back-to-top {
    bottom: 15px;
  }
}

@media (max-width: 767px) {
  #intro .intro-info {
    width: 100%;
  }

  #intro .intro-info h2 {
    font-size: 34px;
    margin-bottom: 30px;
  }

  .section-header p {
    width: 100%;
  }

  #testimonials .testimonial-item {
    text-align: center;
  }

  #testimonials .testimonial-item .testimonial-img {
    float: none;
    margin: auto;
  }

  #testimonials .testimonial-item h3,
  #testimonials .testimonial-item h4,
  #testimonials .testimonial-item p {
    margin-left: 0;
  }
}

@media (max-width: 574px) {
  #intro {
    padding: 100px 0 20px 0;
  }
}

/* Modal Backdrop */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Popup Container */
.popup-container {
  width: 300px;
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
  position: relative;
}

/* Close Button */
.popup-container .close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: #444;
  background: none;
  border: none;
  cursor: pointer;
}

/* Input Fields */
.popup-container .input-field {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
}

/* Buttons */
.popup-container .btn {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.popup-container .btn-primary {
  background-color: #007bff;
  color: #fff;
  border: none;
}

.popup-container .btn-secondary {
  background-color: #6c757d;
  color: #fff;
  border: none;
}

.popup-container .btn:hover {
  opacity: 0.9;
}

/* Footer Links */
.popup-container .popup-footer {
  margin-top: 10px;
  font-size: 12px;
  color: #007bff;
}

.popup-container .popup-footer span {
  cursor: pointer;
  text-decoration: underline;
}

.popup-container .popup-footer span:hover {
  color: #0056b3;
}

.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f7f8fc;
  text-align: center;
  color: #333;
}

.not-found-content {
  max-width: 600px;
  padding: 20px;
}

.not-found-title {
  font-size: 6rem;
  color: #ff6b6b;
  margin: 0;
}

.not-found-subtitle {
  font-size: 2rem;
  margin: 10px 0;
}

.not-found-message {
  font-size: 1rem;
  color: #666;
  margin: 15px 0 30px;
}

.not-found-home-link {
  display: inline-block;
  padding: 10px 20px;
  font-size: 1rem;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.not-found-home-link:hover {
  background-color: #0056b3;
}


.logo img {
  max-height: 50px;
}

.main-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.main-nav ul li {
  margin-left: 20px;
}

.main-nav ul li a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
}

.main-nav ul li a:hover {
  color: #007bff;
}

.login-btn {
  border: none;
  padding: 10px 20px;
  cursor: pointer;
}

.login-btn.btn-primary {
  background-color: #007bff;
  color: #fff;
}

.login-btn.btn-danger {
  background-color: #dc3545;
  color: #fff;
}

.login-btn.btn-primary:hover,
.login-btn.btn-danger:hover {
  opacity: 0.8;
}

.button-group {
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  gap: 10px; /* Add space between buttons */
  margin-top: 1rem; /* Add spacing above the button group */
}

.button-group .btn-primary,
.button-group .btn-danger {
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.button-group .btn-primary {
  background-color: #007bff;
  color: white;
}

.button-group .btn-primary:hover {
  background-color: #0056b3;
}

.button-group .btn-danger {
  background-color: #dc3545;
  color: white;
}

.button-group .btn-danger:hover {
  background-color: #bd2130;
}


/* Hide the nav menu by default on smaller screens */
.main-nav {
  display: none;
}

/* Show nav menu on larger screens */
@media (min-width: 992px) {
  .main-nav {
    display: block;
  }

  .mobile-nav-toggle {
    display: none; /* Hide toggle button on large screens */
  }
}

/* Mobile menu styles */
.mobile-menu-open {
  display: block !important;
}

.mobile-nav-toggle {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAED;;+DAE+D;;AAE/D;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;;EAME,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,uBAAuB;;AAEvB;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,cAAc;;AAEd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EAEZ,+CAA+C;AACjD;;AAcA;EACE;IAEE,uBAAuB;EACzB;;EAEA;IAEE,yBAAyB;EAC3B;AACF;;AAEA;;+DAE+D;;AAE/D;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;+DAE+D;;AAE/D;EACE,WAAW;EACX,kBAAkB;EAClB,yDAA+C;;EAE/C,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;+DAE+D;;AAE/D,uBAAuB;;AAEvB;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;;AAEtB;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;EACP,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;;+DAE+D;;AAE/D;iCACiC;;AAEjC;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,UAAU;AACZ;;AAEA;iCACiC;;AAEjC;EACE,mBAAmB;AACrB;;AAEA;iCACiC;;AAEjC;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EAIZ,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EAKnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;iCACiC;;AAEjC;;EAEE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,wBAAwB;IACtB,4CAA4C;IAC5C,WAAW;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gDAAgD;EAChD,gCAAgC;AAClC;;;AAGA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;iCACiC;;AAEjC;EACE,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EAIP,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EAKnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;iCACiC;;AAEjC;EACE,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;iCACiC;;AAEjC;EACE,gBAAgB;EAChB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EAIV,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;iCACiC;;AAEjC;EACE,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EAIb,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;iCACiC;;AAEjC;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;+DAE+D;;AAE/D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+DAE+D;;AAE/D;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,uBAAuB;;EAEzB;;EAEA;IACE,UAAU;;;IAGV,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,+BAA+B;EAC1D,SAAS,EAAE,8BAA8B;EACzC,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,oDAAoD;AACpD;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa,EAAE,wCAAwC;EACzD;AACF;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;AACf","sourcesContent":["/*\n  Theme Name: NewBiz\n  Theme URL: https://bootstrapmade.com/newbiz-bootstrap-business-template/\n  Author: BootstrapMade.com\n  License: https://bootstrapmade.com/license/\n*/\n\n/*--------------------------------------------------------------\n# General\n--------------------------------------------------------------*/\n\nbody {\n  padding: 0%;\n  background: #fff;\n  color: #444;\n  font-family: \"Open Sans\", sans-serif;\n}\n\na {\n  color: #007bff;\n  transition: 0.5s;\n}\n\na:hover,\na:active,\na:focus {\n  color: #0b6bd3;\n  outline: none;\n  text-decoration: none;\n}\n\np {\n  padding: 0;\n  margin: 0 0 30px 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 400;\n  margin: 0 0 20px 0;\n  padding: 0;\n}\n\n/* Back to top button */\n\n.back-to-top {\n  position: fixed;\n  display: none;\n  background: #007bff;\n  color: #fff;\n  width: 44px;\n  height: 44px;\n  text-align: center;\n  line-height: 1;\n  font-size: 16px;\n  border-radius: 50%;\n  right: 15px;\n  bottom: 15px;\n  transition: background 0.5s;\n  z-index: 11;\n}\n\n.back-to-top i {\n  padding-top: 12px;\n  color: #fff;\n}\n\n/* Prelaoder */\n\n#preloader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  overflow: hidden;\n  background: #fff;\n}\n\n#preloader:before {\n  content: \"\";\n  position: fixed;\n  top: calc(50% - 30px);\n  left: calc(50% - 30px);\n  border: 6px solid #f2f2f2;\n  border-top: 6px solid #007bff;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  -webkit-animation: animate-preloader 1s linear infinite;\n  animation: animate-preloader 1s linear infinite;\n}\n\n@-webkit-keyframes animate-preloader {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes animate-preloader {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*--------------------------------------------------------------\n# Header\n--------------------------------------------------------------*/\n\n#header {\n  height: 80px;\n  transition: all 0.5s;\n  z-index: 997;\n  transition: all 0.5s;\n  padding: 20px 0;\n  background: #fff;\n  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.3);\n}\n\n#header.header-scrolled,\n#header.header-pages {\n  height: 60px;\n  padding: 10px 0;\n}\n\n#header .logo h1 {\n  font-size: 36px;\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n  font-weight: 400;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n}\n\n#header .logo h1 a,\n#header .logo h1 a:hover {\n  color: #00366f;\n  text-decoration: none;\n}\n\n#header .logo img {\n  padding: 0;\n  margin: 7px 0;\n  max-height: 26px;\n}\n\n.main-pages {\n  margin-top: 60px;\n}\n\n/*--------------------------------------------------------------\n# Intro Section\n--------------------------------------------------------------*/\n\n#intro {\n  width: 100%;\n  position: relative;\n  background-image: url('../assets/intro-bg.png');\n\n  background-size: cover;\n  padding: 200px 0 120px 0;\n}\n\n#intro .intro-img {\n  width: 50%;\n  float: right;\n}\n\n#intro .intro-info {\n  width: 50%;\n  float: left;\n}\n\n#intro .intro-info h2 {\n  color: #fff;\n  margin-bottom: 40px;\n  font-size: 48px;\n  font-weight: 700;\n}\n\n#intro .intro-info h2 span {\n  color: #74b5fc;\n  text-decoration: underline;\n}\n\n#intro .intro-info .btn-get-started,\n#intro .intro-info .btn-services {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  display: inline-block;\n  padding: 10px 32px;\n  border-radius: 50px;\n  transition: 0.5s;\n  margin: 0 20px 20px 0;\n  color: #fff;\n}\n\n#intro .intro-info .btn-get-started {\n  background: #007bff;\n  border: 2px solid #007bff;\n  color: #fff;\n}\n\n#intro .intro-info .btn-get-started:hover {\n  background: none;\n  border-color: #fff;\n  color: #fff;\n}\n\n#intro .intro-info .btn-services {\n  border: 2px solid #fff;\n}\n\n#intro .intro-info .btn-services:hover {\n  background: #007bff;\n  border-color: #007bff;\n  color: #fff;\n}\n\n.centered-button{\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n/*--------------------------------------------------------------\n# Navigation Menu\n--------------------------------------------------------------*/\n\n/* Desktop Navigation */\n\n.main-nav {\n  /* Drop Down */\n  /* Deep Drop Down */\n}\n\n.main-nav,\n.main-nav * {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.main-nav > ul > li {\n  position: relative;\n  white-space: nowrap;\n  float: left;\n}\n\n.main-nav a {\n  display: block;\n  position: relative;\n  color: #004289;\n  padding: 10px 15px;\n  transition: 0.3s;\n  font-size: 18px;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n}\n\n.main-nav a:hover,\n.main-nav .active > a,\n.main-nav li:hover > a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.main-nav .drop-down ul {\n  display: block;\n  position: absolute;\n  left: 0;\n  top: calc(100% + 30px);\n  z-index: 99;\n  opacity: 0;\n  visibility: hidden;\n  padding: 10px 0;\n  background: #fff;\n  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);\n  transition: ease all 0.3s;\n}\n\n.main-nav .drop-down:hover > ul {\n  opacity: 1;\n  top: 100%;\n  visibility: visible;\n}\n\n.main-nav .drop-down li {\n  min-width: 180px;\n  position: relative;\n}\n\n.main-nav .drop-down ul a {\n  padding: 10px 20px;\n  font-size: 13px;\n  color: #004289;\n}\n\n.main-nav .drop-down ul a:hover,\n.main-nav .drop-down ul .active > a,\n.main-nav .drop-down ul li:hover > a {\n  color: #007bff;\n}\n\n.main-nav .drop-down > a:after {\n  content: \"\\f107\";\n  font-family: FontAwesome;\n  padding-left: 10px;\n}\n\n.main-nav .drop-down .drop-down ul {\n  top: 0;\n  left: calc(100% - 30px);\n}\n\n.main-nav .drop-down .drop-down:hover > ul {\n  opacity: 1;\n  top: 0;\n  left: 100%;\n}\n\n.main-nav .drop-down .drop-down > a {\n  padding-right: 35px;\n}\n\n.main-nav .drop-down .drop-down > a:after {\n  content: \"\\f105\";\n  position: absolute;\n  right: 15px;\n}\n\n/* Mobile Navigation */\n\n.mobile-nav {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  z-index: 9999;\n  overflow-y: auto;\n  left: -260px;\n  width: 260px;\n  padding-top: 18px;\n  background: rgba(19, 39, 57, 0.8);\n  transition: 0.4s;\n}\n\n.mobile-nav * {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.mobile-nav a {\n  display: block;\n  position: relative;\n  color: #fff;\n  padding: 10px 20px;\n  font-weight: 500;\n}\n\n.mobile-nav a:hover,\n.mobile-nav .active > a,\n.mobile-nav li:hover > a {\n  color: #74b5fc;\n  text-decoration: none;\n}\n\n.mobile-nav .drop-down > a:after {\n  content: \"\\f078\";\n  font-family: FontAwesome;\n  padding-left: 10px;\n  position: absolute;\n  right: 15px;\n}\n\n.mobile-nav .active.drop-down > a:after {\n  content: \"\\f077\";\n}\n\n.mobile-nav .drop-down > a {\n  padding-right: 35px;\n}\n\n.mobile-nav .drop-down ul {\n  display: none;\n  overflow: hidden;\n}\n\n.mobile-nav .drop-down li {\n  padding-left: 20px;\n}\n\n.mobile-nav-toggle {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 9998;\n  border: 0;\n  background: none;\n  font-size: 24px;\n  transition: all 0.4s;\n  outline: none !important;\n  line-height: 1;\n  cursor: pointer;\n  text-align: right;\n}\n\n.mobile-nav-toggle i {\n  margin: 18px 18px 0 0;\n  color: #004289;\n}\n\n.mobile-nav-overly {\n  width: 100%;\n  height: 100%;\n  z-index: 9997;\n  top: 0;\n  left: 0;\n  position: fixed;\n  background: rgba(19, 39, 57, 0.8);\n  overflow: hidden;\n  display: none;\n}\n\n.mobile-nav-active {\n  overflow: hidden;\n}\n\n.mobile-nav-active .mobile-nav {\n  left: 0;\n}\n\n.mobile-nav-active .mobile-nav-toggle i {\n  color: #fff;\n}\n\n/*--------------------------------------------------------------\n# Sections\n--------------------------------------------------------------*/\n\n/* Sections Header\n--------------------------------*/\n\n.section-header h3 {\n  font-size: 36px;\n  color: #283d50;\n  text-align: center;\n  font-weight: 500;\n  position: relative;\n}\n\n.section-header p {\n  text-align: center;\n  margin: auto;\n  font-size: 15px;\n  padding-bottom: 60px;\n  color: #556877;\n  width: 50%;\n}\n\n/* Section with background\n--------------------------------*/\n\n.section-bg {\n  background: #ecf5ff;\n}\n\n/* About Us Section\n--------------------------------*/\n\n#about {\n  background: #fff;\n  padding: 60px 0;\n}\n\n#about .about-container .background {\n  margin: 20px 0;\n}\n\n#about .about-container .content {\n  background: #fff;\n}\n\n#about .about-container .title {\n  color: #333;\n  font-weight: 700;\n  font-size: 32px;\n}\n\n#about .about-container p {\n  line-height: 26px;\n}\n\n#about .about-container p:last-child {\n  margin-bottom: 0;\n}\n\n#about .about-container .icon-box {\n  background: #fff;\n  background-size: cover;\n  padding: 0 0 30px 0;\n}\n\n#about .about-container .icon-box .icon {\n  float: left;\n  background: #fff;\n  width: 64px;\n  height: 64px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  text-align: center;\n  border-radius: 50%;\n  border: 2px solid #007bff;\n  transition: all 0.3s ease-in-out;\n}\n\n#about .about-container .icon-box .icon i {\n  color: #007bff;\n  font-size: 24px;\n}\n\n#about .about-container .icon-box:hover .icon {\n  background: #007bff;\n}\n\n#about .about-container .icon-box:hover .icon i {\n  color: #fff;\n}\n\n#about .about-container .icon-box .title {\n  margin-left: 80px;\n  font-weight: 600;\n  margin-bottom: 5px;\n  font-size: 18px;\n}\n\n#about .about-container .icon-box .title a {\n  color: #283d50;\n}\n\n#about .about-container .icon-box .description {\n  margin-left: 80px;\n  line-height: 24px;\n  font-size: 14px;\n}\n\n#about .about-extra {\n  padding-top: 60px;\n}\n\n#about .about-extra h4 {\n  font-weight: 600;\n  font-size: 24px;\n}\n\n/* Services Section\n--------------------------------*/\n\n#services {\n\n  padding: 10px 0 0px 0;\n  box-shadow: inset 0px 0px 12px 0px rgba(0, 0, 0, 0.1);\n}\n\n#services .box {\n  padding: 30px;\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n\n  margin: 0 auto 40px auto;\n    /* Center the box and set the width to 80% */\n    width: 100%;\n  /* margin: 0 10px 40px 10px; */\n  background: #ffffff;\n  box-shadow: 0 10px 29px 0 rgba(68, 88, 144, 0.1);\n  transition: all 0.3s ease-in-out;\n}\n\n\n#services .box:hover {\n  -webkit-transform: translateY(-5px);\n  transform: translateY(-5px);\n}\n\n#services .icon {\n  position: absolute;\n  left: 2px;\n  padding: 10px 10px;\n  top: calc(50% - 32px);\n}\n\n#services .icon i {\n  font-size: 64px;\n  line-height: 1;\n  transition: 0.5s;\n}\n\n#services .title {\n  margin-left: 40px;\n  font-weight: 700;\n  margin-bottom: 15px;\n  font-size: 18px;\n}\n\n#services .title a {\n  color: #111;\n  padding-left: 15px;\n}\n\n#services .box:hover .title a {\n  color: #007bff;\n}\n\n#services .description {\n  font-size: 14px;\n  margin-left: 40px;\n  line-height: 24px;\n  padding-left: 15px;\n  margin-bottom: 0;\n}\n\n#why-us {\n  padding: 60px 0;\n  background: #004a99;\n}\n\n#why-us .section-header h3,\n#why-us .section-header p {\n  color: #fff;\n}\n\n#why-us .card {\n  background: #00458f;\n  border-color: #00458f;\n  border-radius: 10px;\n  margin: 0 15px;\n  padding: 15px 0;\n  text-align: center;\n  color: #fff;\n  transition: 0.3s ease-in-out;\n  height: 100%;\n}\n\n#why-us .card:hover {\n  background: #003b7a;\n  border-color: #003b7a;\n}\n\n#why-us .card i {\n  font-size: 48px;\n  padding-top: 15px;\n  color: #bfddfe;\n}\n\n#why-us .card h5 {\n  font-size: 22px;\n  font-weight: 600;\n}\n\n#why-us .card p {\n  font-size: 15px;\n  color: #d8eafe;\n}\n\n#why-us .card .readmore {\n  color: #fff;\n  font-weight: 600;\n  display: inline-block;\n  transition: 0.3s ease-in-out;\n  border-bottom: #00458f solid 2px;\n}\n\n#why-us .card .readmore:hover {\n  border-bottom: #fff solid 2px;\n}\n\n#why-us .counters {\n  padding-top: 40px;\n}\n\n#why-us .counters span {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: bold;\n  font-size: 48px;\n  display: block;\n  color: #fff;\n}\n\n#why-us .counters p {\n  padding: 0;\n  margin: 0 0 20px 0;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 14px;\n  color: #cce5ff;\n}\n\n/* Portfolio Section\n--------------------------------*/\n\n#portfolio {\n  padding: 60px 0;\n  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);\n}\n\n#portfolio #portfolio-flters {\n  padding: 0;\n  margin: 5px 0 35px 0;\n  list-style: none;\n  text-align: center;\n}\n\n#portfolio #portfolio-flters li {\n  cursor: pointer;\n  margin: 15px 15px 15px 0;\n  display: inline-block;\n  padding: 6px 20px;\n  font-size: 12px;\n  line-height: 20px;\n  color: #007bff;\n  border-radius: 50px;\n  text-transform: uppercase;\n  background: #ecf5ff;\n  margin-bottom: 5px;\n  transition: all 0.3s ease-in-out;\n}\n\n#portfolio #portfolio-flters li:hover,\n#portfolio #portfolio-flters li.filter-active {\n  background: #007bff;\n  color: #fff;\n}\n\n#portfolio #portfolio-flters li:last-child {\n  margin-right: 0;\n}\n\n#portfolio .portfolio-item {\n  position: relative;\n  overflow: hidden;\n  margin-bottom: 30px;\n}\n\n#portfolio .portfolio-item .portfolio-wrap {\n  overflow: hidden;\n  position: relative;\n  border-radius: 6px;\n  margin: 0;\n}\n\n#portfolio .portfolio-item .portfolio-wrap:hover img {\n  opacity: 0.4;\n  transition: 0.3s;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  text-align: center;\n  opacity: 0;\n  transition: 0.2s linear;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info h4 {\n  font-size: 22px;\n  line-height: 1px;\n  font-weight: 700;\n  margin-bottom: 14px;\n  padding-bottom: 0;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info h4 a {\n  color: #fff;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info h4 a:hover {\n  color: #007bff;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info p {\n  padding: 0;\n  margin: 0;\n  color: #e2effe;\n  font-weight: 500;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-preview,\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-details {\n  display: inline-block;\n  line-height: 1;\n  text-align: center;\n  width: 36px;\n  height: 36px;\n  background: #007bff;\n  border-radius: 50%;\n  margin: 10px 4px 0 4px;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-preview i,\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-details i {\n  padding-top: 6px;\n  font-size: 22px;\n  color: #fff;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-preview:hover,\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-details:hover {\n  background: #3395ff;\n}\n\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-preview:hover i,\n#portfolio .portfolio-item .portfolio-wrap .portfolio-info .link-details:hover i {\n  color: #fff;\n}\n\n#portfolio .portfolio-item .portfolio-wrap:hover {\n  background: #003166;\n}\n\n#portfolio .portfolio-item .portfolio-wrap:hover .portfolio-info {\n  opacity: 1;\n}\n\n/* Testimonials Section\n--------------------------------*/\n\n#testimonials {\n  padding: 60px 0;\n  box-shadow: inset 0px 0px 12px 0px rgba(0, 0, 0, 0.1);\n}\n\n#testimonials .section-header {\n  margin-bottom: 40px;\n}\n\n#testimonials .testimonial-item .testimonial-img {\n  width: 120px;\n  border-radius: 50%;\n  border: 4px solid #fff;\n  float: left;\n}\n\n#testimonials .testimonial-item h3 {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 10px 0 5px 0;\n  color: #111;\n  margin-left: 140px;\n}\n\n#testimonials .testimonial-item h4 {\n  font-size: 14px;\n  color: #999;\n  margin: 0 0 15px 0;\n  margin-left: 140px;\n}\n\n#testimonials .testimonial-item p {\n  font-style: italic;\n  margin: 0 0 15px 140px;\n}\n\n#testimonials .owl-nav,\n#testimonials .owl-dots {\n  margin-top: 5px;\n  text-align: center;\n}\n\n#testimonials .owl-dot {\n  display: inline-block;\n  margin: 0 5px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #ddd;\n}\n\n#testimonials .owl-dot.active {\n  background-color: #007bff;\n}\n\n/* Team Section\n--------------------------------*/\n\n#team {\n  background: #fff;\n  padding: 60px 0;\n  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);\n}\n\n#team .member {\n  text-align: center;\n  margin-bottom: 20px;\n  position: relative;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n#team .member .member-info {\n  opacity: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  transition: 0.2s;\n}\n\n#team .member .member-info-content {\n  margin-top: 50px;\n  transition: margin 0.2s;\n}\n\n#team .member:hover .member-info {\n  background: rgba(0, 62, 128, 0.7);\n  opacity: 1;\n  transition: 0.4s;\n}\n\n#team .member:hover .member-info-content {\n  margin-top: 0;\n  transition: margin 0.4s;\n}\n\n#team .member h4 {\n  font-weight: 700;\n  margin-bottom: 2px;\n  font-size: 18px;\n  color: #fff;\n}\n\n#team .member span {\n  font-style: italic;\n  display: block;\n  font-size: 13px;\n  color: #fff;\n}\n\n#team .member .social {\n  margin-top: 15px;\n}\n\n#team .member .social a {\n  transition: none;\n  color: #fff;\n}\n\n#team .member .social a:hover {\n  color: #007bff;\n}\n\n#team .member .social i {\n  font-size: 18px;\n  margin: 0 2px;\n}\n\n/* Clients Section\n--------------------------------*/\n\n#clients {\n  padding: 60px 0;\n  box-shadow: inset 0px 0px 12px 0px rgba(0, 0, 0, 0.1);\n}\n\n#clients .clients-wrap {\n  border-top: 1px solid #d6eaff;\n  border-left: 1px solid #d6eaff;\n  margin-bottom: 30px;\n}\n\n#clients .client-logo {\n  padding: 64px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-right: 1px solid #d6eaff;\n  border-bottom: 1px solid #d6eaff;\n  overflow: hidden;\n  background: #fff;\n  height: 160px;\n}\n\n#clients .client-logo:hover img {\n  -webkit-transform: scale(1.2);\n  transform: scale(1.2);\n}\n\n#clients img {\n  transition: all 0.4s ease-in-out;\n}\n\n/* Contact Section\n--------------------------------*/\n\n#contact {\n  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);\n  padding: 60px 0;\n  overflow: hidden;\n}\n\n#contact .section-header {\n  padding-bottom: 30px;\n}\n\n#contact .contact-about h3 {\n  font-size: 36px;\n  margin: 0 0 10px 0;\n  padding: 0;\n  line-height: 1;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 300;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  color: #007bff;\n}\n\n#contact .contact-about p {\n  font-size: 14px;\n  line-height: 24px;\n  font-family: \"Montserrat\", sans-serif;\n  color: #888;\n}\n\n#contact .social-links {\n  padding-bottom: 20px;\n}\n\n#contact .social-links a {\n  font-size: 18px;\n  display: inline-block;\n  background: #fff;\n  color: #007bff;\n  line-height: 1;\n  padding: 8px 0;\n  margin-right: 4px;\n  border-radius: 50%;\n  text-align: center;\n  width: 36px;\n  height: 36px;\n  transition: 0.3s;\n  border: 1px solid #007bff;\n}\n\n#contact .social-links a:hover {\n  background: #007bff;\n  color: #fff;\n}\n\n#contact .info {\n  color: #283d50;\n}\n\n#contact .info i {\n  font-size: 32px;\n  color: #007bff;\n  float: left;\n  line-height: 1;\n}\n\n#contact .info p {\n  padding: 0 0 10px 36px;\n  line-height: 28px;\n  font-size: 14px;\n}\n\n#contact .form #sendmessage {\n  color: #007bff;\n  border: 1px solid #007bff;\n  display: none;\n  text-align: center;\n  padding: 15px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n#contact .form #errormessage {\n  color: red;\n  display: none;\n  border: 1px solid red;\n  text-align: center;\n  padding: 15px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n#contact .form #sendmessage.show,\n#contact .form #errormessage.show,\n#contact .form .show {\n  display: block;\n}\n\n#contact .form .validation {\n  color: red;\n  display: none;\n  margin: 0 0 20px;\n  font-weight: 400;\n  font-size: 13px;\n}\n\n#contact .form input,\n#contact .form textarea {\n  border-radius: 0;\n  box-shadow: none;\n  font-size: 14px;\n}\n\n#contact .form button[type=\"submit\"] {\n  background: #007bff;\n  border: 0;\n  border-radius: 20px;\n  padding: 8px 30px;\n  color: #fff;\n  transition: 0.3s;\n}\n\n#contact .form button[type=\"submit\"]:hover {\n  background: #0067d5;\n  cursor: pointer;\n}\n\n/*--------------------------------------------------------------\n# Footer\n--------------------------------------------------------------*/\n\n#footer {\n  background: #00428a;\n  padding: 0 0 30px 0;\n  color: #eee;\n  font-size: 14px;\n}\n\n#footer .footer-top {\n  background: #004a99;\n  padding: 60px 0 30px 0;\n}\n\n#footer .footer-top .footer-info {\n  margin-bottom: 30px;\n}\n\n#footer .footer-top .footer-info h3 {\n  font-size: 34px;\n  margin: 0 0 20px 0;\n  padding: 2px 0 2px 0;\n  line-height: 1;\n  font-family: \"Montserrat\", sans-serif;\n  color: #fff;\n  font-weight: 400;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n}\n\n#footer .footer-top .footer-info p {\n  font-size: 13px;\n  line-height: 24px;\n  margin-bottom: 0;\n  font-family: \"Montserrat\", sans-serif;\n  color: #ecf5ff;\n}\n\n#footer .footer-top .social-links a {\n  font-size: 18px;\n  display: inline-block;\n  background: #007bff;\n  color: #fff;\n  line-height: 1;\n  padding: 8px 0;\n  margin-right: 4px;\n  border-radius: 50%;\n  text-align: center;\n  width: 36px;\n  height: 36px;\n  transition: 0.3s;\n}\n\n#footer .footer-top .social-links a:hover {\n  background: #0067d5;\n  color: #fff;\n}\n\n#footer .footer-top h4 {\n  font-size: 14px;\n  font-weight: bold;\n  color: #fff;\n  text-transform: uppercase;\n  position: relative;\n  padding-bottom: 10px;\n}\n\n#footer .footer-top .footer-links {\n  margin-bottom: 30px;\n}\n\n#footer .footer-top .footer-links ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n#footer .footer-top .footer-links ul li {\n  padding: 8px 0;\n}\n\n#footer .footer-top .footer-links ul li:first-child {\n  padding-top: 0;\n}\n\n#footer .footer-top .footer-links ul a {\n  color: #ecf5ff;\n}\n\n#footer .footer-top .footer-links ul a:hover {\n  color: #74b5fc;\n}\n\n#footer .footer-top .footer-contact {\n  margin-bottom: 30px;\n}\n\n#footer .footer-top .footer-contact p {\n  line-height: 26px;\n}\n\n#footer .footer-top .footer-newsletter {\n  margin-bottom: 30px;\n}\n\n#footer .footer-top .footer-newsletter input[type=\"email\"] {\n  border: 0;\n  padding: 6px 8px;\n  width: 65%;\n}\n\n#footer .footer-top .footer-newsletter input[type=\"submit\"] {\n  background: #007bff;\n  border: 0;\n  width: 35%;\n  padding: 6px 0;\n  text-align: center;\n  color: #fff;\n  transition: 0.3s;\n  cursor: pointer;\n}\n\n#footer .footer-top .footer-newsletter input[type=\"submit\"]:hover {\n  background: #0062cc;\n}\n\n#footer .copyright {\n  text-align: center;\n  padding-top: 30px;\n}\n\n#footer .credits {\n  text-align: center;\n  font-size: 13px;\n  color: #f1f7ff;\n}\n\n#footer .credits a {\n  color: #bfddfe;\n}\n\n#footer .credits a:hover {\n  color: #f1f7ff;\n}\n\n/*--------------------------------------------------------------\n# Responsive Media Queries\n--------------------------------------------------------------*/\n\n@media (min-width: 992px) {\n  #testimonials .testimonial-item p {\n    width: 80%;\n  }\n}\n\n@media (max-width: 991px) {\n  #header {\n    height: 60px;\n    padding: 10px 0;\n  }\n\n  #header .logo h1 {\n    font-size: 28px;\n    padding: 8px 0;\n  }\n\n  #intro {\n    padding: 140px 0 60px 0;\n\n  }\n\n  #intro .intro-img {\n    width: 80%;\n\n\n    float: none;\n    margin: 0 auto 25px auto;\n  }\n\n  #intro .intro-info {\n    width: 80%;\n    float: none;\n    margin: auto;\n    text-align: center;\n  }\n\n  #why-us .card {\n    margin: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .back-to-top {\n    bottom: 15px;\n  }\n}\n\n@media (max-width: 767px) {\n  #intro .intro-info {\n    width: 100%;\n  }\n\n  #intro .intro-info h2 {\n    font-size: 34px;\n    margin-bottom: 30px;\n  }\n\n  .section-header p {\n    width: 100%;\n  }\n\n  #testimonials .testimonial-item {\n    text-align: center;\n  }\n\n  #testimonials .testimonial-item .testimonial-img {\n    float: none;\n    margin: auto;\n  }\n\n  #testimonials .testimonial-item h3,\n  #testimonials .testimonial-item h4,\n  #testimonials .testimonial-item p {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 574px) {\n  #intro {\n    padding: 100px 0 20px 0;\n  }\n}\n\n/* Modal Backdrop */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Popup Container */\n.popup-container {\n  width: 300px;\n  padding: 20px;\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  position: relative;\n}\n\n/* Close Button */\n.popup-container .close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #444;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n/* Input Fields */\n.popup-container .input-field {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n/* Buttons */\n.popup-container .btn {\n  width: 100%;\n  padding: 10px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.popup-container .btn-primary {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n}\n\n.popup-container .btn-secondary {\n  background-color: #6c757d;\n  color: #fff;\n  border: none;\n}\n\n.popup-container .btn:hover {\n  opacity: 0.9;\n}\n\n/* Footer Links */\n.popup-container .popup-footer {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #007bff;\n}\n\n.popup-container .popup-footer span {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.popup-container .popup-footer span:hover {\n  color: #0056b3;\n}\n\n.not-found-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f7f8fc;\n  text-align: center;\n  color: #333;\n}\n\n.not-found-content {\n  max-width: 600px;\n  padding: 20px;\n}\n\n.not-found-title {\n  font-size: 6rem;\n  color: #ff6b6b;\n  margin: 0;\n}\n\n.not-found-subtitle {\n  font-size: 2rem;\n  margin: 10px 0;\n}\n\n.not-found-message {\n  font-size: 1rem;\n  color: #666;\n  margin: 15px 0 30px;\n}\n\n.not-found-home-link {\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 1rem;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 5px;\n  text-decoration: none;\n  transition: background-color 0.3s ease;\n}\n\n.not-found-home-link:hover {\n  background-color: #0056b3;\n}\n\n\n.logo img {\n  max-height: 50px;\n}\n\n.main-nav ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n}\n\n.main-nav ul li {\n  margin-left: 20px;\n}\n\n.main-nav ul li a {\n  color: #333;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.main-nav ul li a:hover {\n  color: #007bff;\n}\n\n.login-btn {\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n}\n\n.login-btn.btn-primary {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.login-btn.btn-danger {\n  background-color: #dc3545;\n  color: #fff;\n}\n\n.login-btn.btn-primary:hover,\n.login-btn.btn-danger:hover {\n  opacity: 0.8;\n}\n\n.button-group {\n  display: flex;\n  justify-content: flex-end; /* Align buttons to the right */\n  gap: 10px; /* Add space between buttons */\n  margin-top: 1rem; /* Add spacing above the button group */\n}\n\n.button-group .btn-primary,\n.button-group .btn-danger {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.button-group .btn-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.button-group .btn-primary:hover {\n  background-color: #0056b3;\n}\n\n.button-group .btn-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.button-group .btn-danger:hover {\n  background-color: #bd2130;\n}\n\n\n/* Hide the nav menu by default on smaller screens */\n.main-nav {\n  display: none;\n}\n\n/* Show nav menu on larger screens */\n@media (min-width: 992px) {\n  .main-nav {\n    display: block;\n  }\n\n  .mobile-nav-toggle {\n    display: none; /* Hide toggle button on large screens */\n  }\n}\n\n/* Mobile menu styles */\n.mobile-menu-open {\n  display: block !important;\n}\n\n.mobile-nav-toggle {\n  font-size: 24px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
